module.exports = __webpack_public_path__ + "img/icon_desktop_incidencia.3b0d7011.png";